"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DateTimePicker = _interopRequireDefault(require("./DateTimePicker.vue"));
var _default = exports.default = {
  name: 'YsDateTimeRangePicker',
  components: {
    DateTimePicker: _DateTimePicker.default
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    precision: {
      type: String,
      default: 'second',
      validator: value => ['hour', 'minute', 'second'].includes(value)
    }
  },
  data() {
    return {
      beginOpen: false,
      endOpen: false,
      selectRange: JSON.parse(JSON.stringify(this.value ?? []))
    };
  },
  computed: {
    showClear() {
      if (!this.allowClear) {
        return false;
      }
      const [begin, end] = this.value || [];
      return begin || end;
    }
  },
  watch: {
    value: {
      handler(value) {
        this.selectRange = JSON.parse(JSON.stringify(value ?? []));
      },
      deep: true
    }
  },
  methods: {
    handleBeginOpenChange(open) {
      this.beginOpen = open;
    },
    handleBeginConfirm(value) {
      if (value) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      if (open && !this.selectRange[0]) {
        this.endOpen = false;
        this.beginOpen = true;
      } else {
        this.endOpen = open;
      }
      if (!open && !this.selectRange[1]) {
        this.selectRange = JSON.parse(JSON.stringify(this.value ?? []));
      }
    },
    handleEndConfirm(value) {
      if (!value) {
        this.selectRange = JSON.parse(JSON.stringify(this.value ?? []));
        return;
      }
      this.$emit('input', this.selectRange);
    },
    handleClear() {
      this.selectRange = [undefined, undefined];
      this.$emit('input', [undefined, undefined]);
    }
  }
};